import React, { useContext, useEffect, useState } from 'react';
import { Button, CloseIcon, Input, Modal, RadioButton } from 'components';
import { useLocation, useNavigate } from 'react-router-dom';
import { SettingsStyles } from './Settings.styles';
import { useSelector, useDispatch } from 'react-redux';
import {
  ChangePasswordApi,
  ChangeUserRoleApi,
  ValidateUserApi,
  VerifyPhoneAndEmail,
  UpdateAuthData,
  DeleteAccountApi,
  handleGetUpdateUsernameOTP,
  handleChangeUserName,
} from 'redux/features/LoginSlice';
import { Notification } from 'components/CustomNotification';
import { ReactComponent as Arrowforward } from 'assert/images/Common/arrowForward.svg';
import { Decrptdata } from 'components/Decrptdata';
import { getProfileByuserId } from 'redux/features/ProfileSlice';
import SettingsOTPVerification from './SettingsOTPVerification';
import clsx from 'clsx';
// import { IconButton, InputAdornment } from '@mui/material';
// import { ReactComponent as Visibility } from 'assert/images/Common/visibility.svg';
// import { ReactComponent as VisibilityOff } from 'assert/images/Common/visibilityOff.svg';
import CheckBox from 'components/CheckBox';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth, usernameRegex } from 'utils/helper';
import { AuthContext } from 'router/AuthProvider';

const settingsPath = [
  '/username',
  '/password',
  '/email',
  '/phone',
  '/account-type',
  '/delete-account',
];

export default function AccountInformation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const { recheckAuth } = useContext(AuthContext);

  const { authData } = useSelector((state) => state?.LoginReducer);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const profileData = getProfile;
  const UserId = profileData?.userId;

  const [seconds, setSeconds] = useState(0);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [slideChange, setSlideChange] = useState();
  const [modalOpen, setModalOpen] = useState(null);
  const [openValidateUsername, setOpenValidateUsername] = useState(false);
  // const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [showAllPassword, setShowAllPassword] = useState(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const initialState = {
    username: '',
    usernameOTP: '',
    confirm_password: '',
    new_password: '',
    current_password: '',
    otp: '',
    sid: '',
    email: '',
    usertype: '',
    phone: '',
  };
  const initialErrMsg = {
    username: '',
    usernameOTP: '',
    confirm_password: '',
    new_password: '',
    current_password: '',
    usertype: '',
    otp: '',
    email: '',
  };
  const [state, setState] = useState({ ...initialState });
  const [errMsg, setErrmsg] = useState({ ...initialErrMsg });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      usertype: profileData?.accountType,
    }));
  }, [profileData]);

  useEffect(() => {
    const slideIndex = settingsPath.findIndex((path) =>
      pathname?.endsWith(path)
    );
    setSlideChange(slideIndex >= 0 ? slideIndex : null);
  }, [pathname]);

  useEffect(() => {
    if (authData?.success) {
      if ([0, 1, 4].includes(slideChange) || isOtpVerified) {
        // if ([0].includes(slideChange)) {
        //   localStorage.setItem('username', state?.username);
        // }
        resetAll();
      }
      dispatch(UpdateAuthData(''));
      setIsLoading(false);
    } else if (!authData?.success) {
      setIsLoading(false);
    }
  }, [authData]);

  useEffect(() => {
    if (getProfile?.accountType) {
      setState((prevState) => ({
        ...prevState,
        usertype: getProfile?.accountType,
      }));
    }
  }, [getProfile]);

  const decrptedEmail = profileData?.userEmail;
  const decrptedPhone = Decrptdata(profileData?.phoneNo || '');

  const handleChange = (data, key) => {
    if (key === 'usertype') {
      dispatch(ChangeUserRoleApi(data, UserId))
        .then((response) => {
          dispatch(UpdateAuthData(response?.data));
          dispatch(getProfileByuserId(UserId));
          setModalOpen(null);
          Notification('success', 'Account Type Changed');
        })
        .catch((err) => {
          setModalOpen(null);
          Notification(
            'error',
            err.response?.data?.message || 'Something went wrong'
          );
        });
    }

    // Username validation
    if (key === 'username') {
      const trimmed = data.trim();
      if (trimmed.length < 3 || trimmed.length > 50) {
        setErrmsg((prev) => ({
          ...prev,
          username: 'Username must be 3–50 characters',
        }));
      } else if (!usernameRegex.test(trimmed)) {
        setErrmsg((prev) => ({
          ...prev,
          username: 'Only letters, numbers, and underscores are allowed',
        }));
      } else {
        setErrmsg((prev) => ({
          ...prev,
          username: '',
        }));
      }
    }

    setState((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const AccountMenu = () => {
    const AccountInfo = [
      {
        id: 1,
        name: 'Settings.userName',
        displaynames: profileData?.username,
        path: '/username',
      },
      {
        id: 2,
        name: 'Settings.Password',
        displaynames: '********',
        path: '/password',
      },
      {
        id: 3,
        name: 'Settings.Email',
        displaynames: decrptedEmail || (
          <span className="add-emailPhone">Add</span>
        ),
        path: '/email',
      },
      {
        id: 4,
        name: 'Settings.Phone',
        displaynames: decrptedPhone || (
          <span className="add-emailPhone">Add</span>
        ),
        path: '/phone',
      },
      {
        id: 5,
        name: 'Settings.AccountType',
        displaynames: profileData?.accountType ? 'Organization' : 'Personal',
        path: '/account-type',
      },
      { id: 6, name: 'Settings.DeleteAccount', path: '/delete-account' },
    ];

    return AccountInfo.map((data, index) => (
      <div
        key={index}
        className={clsx(
          'setting-menu',
          (getProfile?.authProvider === 'google' ||
            getProfile?.authProvider === 'IOS') &&
            (data.id === 2 || data.id === 3) &&
            'hide-account-item'
        )}
        onClick={() => {
          navigate(`/settings${data.path}`);
          setSlideChange(index);
          setIsOtpVerified(false);
        }}
      >
        <div>{t(data.name)}</div>
        <div>
          <div>{data.displaynames}</div>
          <Arrowforward className="right-arrow" />
        </div>
      </div>
    ));
  };

  const handleValidation = () => {
    let array = [];
    if (slideChange === 0) {
      // 'current_password',
      array = ['username', 'usernameOTP'];
    } else if (slideChange === 1) {
      array = ['new_password', 'current_password', 'confirm_password'];
    } else if (slideChange === 2) {
      array = isOtpVerified ? ['otp'] : ['current_password', 'email'];
    } else if (slideChange === 3) {
      array = isOtpVerified
        ? ['current_password', 'otp']
        : ['current_password', 'phone'];
    }

    array.forEach((data) => {
      const value = state[data]?.trim();

      if (!value) {
        errMsg[data] = 'Field Required';
        return;
      }

      if (
        ['current_password', 'new_password', 'confirm_password'].includes(
          data
        ) &&
        value.length < 6
      ) {
        errMsg[data] = t('Auth.passsixreq');
        return;
      }

      if (data === 'confirm_password' && value !== state.new_password.trim()) {
        errMsg.confirm_password = "Confirm password doesn't match";
        return;
      }

      if (data === 'username') {
        if (value.length < 3 || value.length > 50) {
          errMsg.username = 'Username must be 3–50 characters';
          return;
        } else if (!usernameRegex.test(value)) {
          errMsg.username =
            'Only letters, numbers, and underscores are allowed';
          return;
        }
      }

      if (data === 'usernameOTP') {
        if (value?.length !== 6) {
          errMsg.usernameOTP = 'OTP is not valid';
          return;
        }
      }

      errMsg[data] = '';
    });

    setState((prev) => ({
      ...prev,
    }));
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const VerifyAndOtpReceive = (otps) => {
    setIsOtpVerified(true);
    setState((prevState) => ({
      ...prevState,
      otp: otps,
    }));
  };

  const StateDetailsFun = (value) => {
    setState((prevState) => ({
      ...prevState,
      email: value.email,
      current_password: value.password,
      sid: value.sid,
    }));
  };

  const ChangeUserName = () => {
    return (
      <>
        {!openValidateUsername ? (
          <Input
            label={t('Settings.NewUserName')}
            type="text"
            value={state.username}
            onChange={(data) => handleChange(data, 'username')}
            errMsg={errMsg?.username}
          />
        ) : (
          <>
            <Input
              type={'text'}
              value={state.usernameOTP}
              label="Enter the OTP to change the username"
              onChange={(data) => handleChange(data, 'usernameOTP')}
              errMsg={errMsg?.usernameOTP}
            />
            <div className="otp-resend">
              <span>{t('Auth.DontReceive')}</span>
              {seconds === 0 ? (
                <a
                  onClick={() => {
                    setSeconds(30);
                    handleCallUsernameOTP();
                  }}
                >
                  {t('Auth.SendAgain')}
                </a>
              ) : (
                <div>{seconds}s</div>
              )}
            </div>
          </>
        )}
        {/* <Input
          label={t('Settings.Password')}
          type={newPasswordShow ? 'text' : 'password'}
          value={state.current_password}
          onChange={(data) => handleChange(data, 'current_password')}
          errMsg={errMsg?.current_password}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setNewPasswordShow(!newPasswordShow)}
                edge="end"
              >
                {newPasswordShow ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        /> */}
      </>
    );
  };

  const ChangePasswordComp = () => {
    return (
      <>
        <Input
          label={t('Settings.CurrentPwd')}
          type={showAllPassword ? 'text' : 'password'}
          value={state.current_password}
          onChange={(data) => handleChange(data, 'current_password')}
          errMsg={errMsg.current_password}
        />
        <Input
          label={t('Settings.NewPwd')}
          type={showAllPassword ? 'text' : 'password'}
          value={state.new_password}
          onChange={(data) => handleChange(data, 'new_password')}
          errMsg={errMsg?.new_password}
        />
        <Input
          label={t('Settings.ConfirmPwd')}
          type={showAllPassword ? 'text' : 'password'}
          value={state.confirm_password}
          onChange={(data) => handleChange(data, 'confirm_password')}
          errMsg={errMsg?.confirm_password}
        />
        <CheckBox
          label={t('Settings.ShowPwd')}
          onChange={() => setShowAllPassword(!showAllPassword)}
          value={showAllPassword}
          size="small"
        />
      </>
    );
  };

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  const otpVerifyComp = () => {
    const SendAgainOtp = () => {
      setSeconds(30);
      const payload = {
        validateType: slideChange === 2 ? 'userEmail' : 'userPhone',
        password: state.current_password,
        userDetail: slideChange === 3 ? decrptedPhone : decrptedEmail,
        newUserMail: state.email,
      };
      dispatch(ValidateUserApi(payload, UserId, true));
    };
    return (
      <>
        <Input
          type={'text'}
          value={state.otp}
          label="Enter the OTP to verify the email"
          onChange={(data) => handleChange(data, 'otp')}
          errMsg={errMsg.otp}
        />
        <div className="otp-resend">
          <span>{t('Auth.DontReceive')}</span>
          {seconds === 0 ? (
            <a onClick={SendAgainOtp}>{t('Auth.SendAgain')}</a>
          ) : (
            <div>{seconds}s</div>
          )}
        </div>
      </>
    );
  };

  const AccountTypeComp = () => {
    const UserType = [
      {
        id: 0,
        label: t('Settings.Personal'),
        value: 0,
      },
      {
        id: 1,
        label: t('Settings.Organization'),
        value: 1,
      },
    ];
    return (
      <div className="account-type-container">
        <RadioButton
          fontSize={24}
          options={UserType}
          value={state?.usertype || 0}
          onChange={(e) => setModalOpen(e.target.value)}
        />
      </div>
    );
  };

  const DeleteComp = () => {
    return (
      <>
        <div>
          <b>{t('Settings.DeleteAccountPermanent')}</b>
        </div>
        <p>{t('Settings.DeleteDefinition')}</p>
      </>
    );
  };

  const RenderComp = () => {
    if (slideChange === 0) {
      return ChangeUserName();
    } else if (slideChange === 1) {
      return ChangePasswordComp();
    } else if (slideChange === 2) {
      return isOtpVerified ? (
        otpVerifyComp()
      ) : (
        <SettingsOTPVerification
          email={true}
          mobile={false}
          slideChange={slideChange}
          decrptedEmail={decrptedEmail}
          decrptedPhone={decrptedPhone}
          verifyFun={VerifyAndOtpReceive}
          StateDetailsFun={StateDetailsFun}
        />
      );
    } else if (slideChange === 3) {
      return isOtpVerified ? (
        otpVerifyComp()
      ) : (
        <SettingsOTPVerification
          email={false}
          mobile={true}
          slideChange={slideChange}
          decrptedEmail={decrptedEmail}
          decrptedPhone={decrptedPhone}
          verifyFun={VerifyAndOtpReceive}
        />
      );
    } else if (slideChange === 4) {
      return AccountTypeComp();
    } else if (slideChange === 5) {
      return DeleteComp();
    } else {
      return <AccountMenu />;
    }
  };

  const titleName = () => {
    switch (slideChange) {
      case 0:
        return t('Settings.ChangeUsername');
      case 1:
        return t('Settings.ChangePassword');
      case 2:
        return t('Settings.VerifyPassword');
      case 3:
        return t('Settings.ChangeNumber');
      case 4:
        return t('Settings.AccountType');
      case 5:
        return t('Settings.DeleteAccount');
      default:
        return t('Settings.AccountInformation');
    }
  };

  const ApiActions = () => {
    if (slideChange === 0) {
      setIsLoading(true);
      const changeUserPayload = {
        newUserName: state.username,
        sid: state.sid,
        otp: state.usernameOTP,
      };
      dispatch(handleChangeUserName(changeUserPayload))
        .then((res) => {
          dispatch(getProfileByuserId(UserId));
          resetAll();
          Notification('success', res?.data?.message);
          navigate('/settings/account');
        })
        .catch((err) => {
          setIsLoading(false);
          Notification('error', err?.data?.message);
        });
    } else if (slideChange === 1) {
      dispatch(ChangePasswordApi(state, UserId));
    } else if ([2, 3].includes(slideChange)) {
      const payload = {
        validateType: [0, 1].includes(slideChange)
          ? 'username'
          : slideChange === 2
          ? 'userEmail'
          : slideChange === 3
          ? 'userPhone'
          : '',
        password: state.current_password,
        userDetail:
          slideChange === 0
            ? profileData?.username
            : slideChange === 2
            ? ''
            : state.current_password,
        newUserMail: state.email,
        newUserName: state.username,
      };

      const payload2 = {
        userEmail: decrptedEmail,
        sid: state.sid,
        newUserEmail: state.email || state.phone,
        otp: state.otp,
      };
      isOtpVerified
        ? dispatch(VerifyPhoneAndEmail(payload2))
        : dispatch(ValidateUserApi(payload, UserId));
    } else if (slideChange === 4) {
      dispatch(ChangeUserRoleApi(state, UserId));
    }
  };

  const handleDeleteAccount = () => {
    setIsLoading(true);
    dispatch(DeleteAccountApi(UserId))
      .then((res) => {
        localStorage.removeItem('token');
        setIsLoading(false);
        recheckAuth();
        navigate('/signup');
        setTimeout(() => {
          Notification('success', res?.data?.message);
        }, 1000);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleCallUsernameOTP = () => {
    setIsLoading(true);
    const payload = {
      newUserName: state.username,
    };
    dispatch(handleGetUpdateUsernameOTP(payload))
      .then((response) => {
        const data = response?.data;
        Notification('success', data?.message);
        !openValidateUsername && setOpenValidateUsername(true);
        setState((prevState) => ({
          ...prevState,
          sid: data?.data?.sid,
        }));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrmsg({
          username: err?.response?.data?.message,
        });
        console.log(err);
      });
  };

  const Submit = () => {
    if (slideChange === 0 && !openValidateUsername) {
      handleCallUsernameOTP();
      return;
    }
    if (slideChange === 5) {
      setDeletePopupOpen(true);
      return;
    }
    handleValidation();
    const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
    if (validation) {
      setIsLoading(true);
      ApiActions();
    }
  };

  const handleShowBtn = () => {
    if (
      (isOtpVerified && [1, 2, 3].includes(slideChange)) ||
      [0, 1, 5].includes(slideChange)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isFormValid = () => {
    let validationArr = [];
    if (slideChange === 0) {
      // 'current_password',
      validationArr = ['username'];
    } else if (slideChange === 1) {
      validationArr = ['new_password', 'current_password', 'confirm_password'];
    } else if (slideChange === 2) {
      validationArr = isOtpVerified ? ['otp'] : ['current_password', 'email'];
    } else if (slideChange === 3) {
      validationArr = isOtpVerified
        ? ['current_password', 'otp']
        : ['current_password', 'phone'];
    }
    return validationArr.every((li) => {
      if (slideChange === 0) {
        if (openValidateUsername) {
          return state.usernameOTP?.length === 6;
        } else {
          const isLengthValid = state[li].length >= 3 && state[li].length <= 50;
          const isFormatValid = usernameRegex.test(state[li]);
          return isLengthValid && isFormatValid;
        }
      } else {
        return state[li]?.length > 0;
      }
    });
  };

  const resetAll = () => {
    setState({
      ...initialState,
    });
    setErrmsg({
      ...initialErrMsg,
    });
    setIsOtpVerified(false);
    setOpenValidateUsername(false);
    setSeconds(0);
    navigate(-1);
  };

  return (
    <SettingsStyles>
      {(slideChange === null || slideChange >= 0) && (
        <div className="setting-info-container">
          <div className="setting-title">
            {(slideChange !== null || isSmallScreen) && (
              <CloseIcon
                customStyle="back-icon"
                iconType="back"
                onClick={resetAll}
              />
            )}
            {titleName()}
          </div>
          <div
            className={clsx(slideChange !== null && 'setting-action-content')}
          >
            <div className="inputbox">{RenderComp()}</div>
            {slideChange !== null && handleShowBtn() && (
              <div className="setbtn">
                <Button
                  label={t('Settings.Cancel')}
                  onClick={resetAll}
                  variant="outlined"
                />
                <Button
                  disabled={!isFormValid()}
                  label={
                    slideChange === 0 && !openValidateUsername
                      ? t('Settings.SendOTP')
                      : t('Settings.Submit')
                  }
                  onClick={isFormValid() ? Submit : () => {}}
                  loading={isLoading}
                  loadingIndicator="Loading…"
                />
              </div>
            )}
          </div>
        </div>
      )}
      <Modal
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setModalOpen(null)}
        openModal={modalOpen !== null}
        content={
          <div className="confirmModal">
            <div className="title">
              {t('Settings.ChangeAccount')}
              <br />
              {t('Settings.AccountTypeConfirmation')}
            </div>
            {t('Settings.ProfileDetailsChange')}
            <div>
              <Button
                label={t('Settings.Cancel')}
                variant="text"
                onClick={() => setModalOpen(null)}
              />
              <Button
                label={t('Settings.Yes')}
                color="error"
                onClick={() => handleChange(modalOpen, 'usertype')}
              />
            </div>
          </div>
        }
      />
      <Modal
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setDeletePopupOpen(false)}
        openModal={deletePopupOpen}
        content={
          <div className="confirmModal">
            <div className="title">
              Are you sure you want to delete this account?
              <br />
              You cannot undo this action.
            </div>
            <div>
              <Button
                label={t('Settings.Cancel')}
                variant="text"
                onClick={() => setDeletePopupOpen(false)}
              />
              <Button
                disableElevation
                label={t('Settings.Yes')}
                color="error"
                onClick={handleDeleteAccount}
              />
            </div>
          </div>
        }
      />
    </SettingsStyles>
  );
}
